import React, { useState, useEffect } from 'react';
import { Container, Grid, Button, Box, Typography, IconButton } from '@mui/material';
import Calendar from '../../../../components/Calendar/LandingCalendar';
import Availability from '../Availability';
import styles from './styles.module.scss';
import Hr from '../../../../components/Hr';
import { grey, red, teal } from '@mui/material/colors';
import GallerySlick from './GallerySlick';
import dayjs from 'dayjs';
import client from '../../../../modules/axios';
import { API } from '../../../../config/path';
import { useApp } from '../../../../context/appContext';
import LearnMoreCancellationButton from '../LearnMoreCancellationButton';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
const initDate = dayjs().add(1, 'day').format('YYYY-MM-DD');

const Gallery = (props) => {
  const initDataAvability = {
    id_product: null,
    adult: 1,
    child: 0,
    infant: 0,
  };
  const { snackbar, setSnackbar } = useApp();

  const [date, setDate] = useState(initDate);
  const [travelers, setTravelers] = useState({});
  const [productImages, setProductImages] = useState([]);
  const [isSShowDetail, setIsShowDetail] = useState(false);
  const [dataAvability, setDataAvability] = useState(initDataAvability);
  const [resAvabilityDetail, setResAvabilityDetail] = useState(null);

  const [addons, setAddons] = useState([]);

  const handleAddonChange = (index, delta) => {
    setAddons((prev) =>
      prev.map((addon, i) =>
        i === index ? { ...addon, qty: Math.max(0, addon.qty + delta) } : addon
      )
    );
  };

  const totalAddonPrice = addons.reduce((sum, addon) => sum + addon.price * addon.qty, 0);

  const selectedAddons = addons
    .filter((addon) => addon.qty > 0)
    .map((addon) => ({ addon_id: addon.id, qty: addon.qty }));


  useEffect(() => {
    if (props.product) {
      // let images = [];
      // props.product.product_gallery?.map((image) => images.push(image.image));
      // setProductImages([props.product.product_image, ...images]);

      const images = [
        {
          image: props.product.product_image,
          image_title: props.product.product_image_title,
          image_alt: props.product.product_image_alt,
        },
        ...(props.product.product_gallery || []),
      ];
      setProductImages(images);

      setDataAvability({
        ...dataAvability,
        id_product: props.product.id,
      });
    }
  }, [props.product]);

  const handleClick = (e) => {
    e.preventDefault();

    client
      .post(API.AVABILITY_DETAIL, dataAvability)
      .then((res) => {
        if (res.data.success) {
          const detail = res.data.data;
          setResAvabilityDetail(detail);
          // Seed addons from API response, preserving existing qty if re-checked
          if (Array.isArray(detail.addon)) {
            setAddons((prev) =>
              detail.addon.map((a) => {
                const existing = prev.find((p) => p.id === a.id);
                return { ...a, qty: existing ? existing.qty : 0 };
              })
            );
          }
          setIsShowDetail(true);

          const element = document.getElementById('product-show-detail');
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }

          return;
        }

        setSnackbar({
          ...snackbar,
          open: true,
          message: 'Something went wrong',
          type: 'error',
        });
      })
      .catch((err) => {
        console.log('err', err);
        setSnackbar({
          ...snackbar,
          open: true,
          message: 'Internal server error',
          type: 'error',
        });
      });
  };

  return (
    <Container>
      <Box
        sx={{
          my: 2,
        }}>
        <Grid container columnSpacing={2} rowSpacing={2}>
          <Grid item xs={12} md={8}>
            {productImages.length > 0 && (
              <GallerySlick
                images={productImages}
              // product_image_title={props.product_image_title}
              />
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: grey[200],
                height: '100%',
                borderRadius: 2,
              }}>
              <Box
                sx={{
                  p: 2,
                }}>
                <Box
                  sx={{
                    borderBottom: '1px solid' + grey[500],
                    mb: 2,
                  }}>
                  <Typography variant="body1">
                    From <span className={styles.price}>${props.product.start_price}</span>
                  </Typography>
                  <Typography variant="body2" mb={2}>
                    Price Varies by group size
                  </Typography>
                  <Typography variant="body1" color={teal[900]}>
                    Lowest Price Guarantee
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    mb: 1,
                  }}>
                  <Typography variant="h4">Select Date and Travelers</Typography>
                  <Calendar
                    initDate={date}
                    minDate={dayjs()}
                    onChange={(e) => {
                      setDate(e);
                    }}
                  />
                  <Availability
                    traveler={props.product.price_check}
                    onChange={(e) => {
                      setTravelers(e);
                      setDataAvability({
                        ...dataAvability,
                        adult: e.adult,
                        child: e.child,
                        infant: e.infant,
                      });
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={(e) => handleClick(e)}
                    sx={{
                      backgroundColor: red[800],
                      borderColor: red[800],
                      '&:hover': {
                        backgroundColor: red[900],
                        borderColor: red[900],
                      },
                    }}>
                    Book Now
                  </Button>
                </Box>
                <Typography variant="body2" fontWeight={600}>
                  Free cancellation
                </Typography>
                <Typography variant="body2">
                  Up to 24 hours in advance. <LearnMoreCancellationButton />
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {isSShowDetail && (
        <Box
          id="product-show-detail"
          sx={{
            px: {
              md: 2,
            },
            py: 1,
          }}>
          <Grid
            container
            sx={{
              border: '1px solid' + grey[400],
              borderRadius: 1.5,
            }}>
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                borderRight: {
                  xs: 'none',
                  md: '1px solid' + grey[400],
                },
                borderBottom: {
                  xs: '1px solid' + grey[400],
                  md: 'none',
                },
                p: {
                  xs: 2,
                  md: 4,
                },
              }}>

              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    mb: {
                      xs: 2,
                      md: 2,
                    },
                  }}>
                  {resAvabilityDetail?.product_name}
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  mb: {
                    xs: 1,
                    md: 1,
                  },
                  mt: {
                    xs: 1,
                    md: 1,
                  },
                }}>
                Pickup included
              </Typography>

              <Button variant="contained">{resAvabilityDetail?.departure_time}</Button>

              {/* addon list */}
              {(addons.length > 0) && (
                <Box
                  sx={{
                    mt: 3,
                    border: '1px solid' + grey[400],
                    borderRadius: 1.5,
                    p: { xs: 1, md: 2 }
                  }}>
                  <Typography variant="h6" fontWeight="bold" mb={1}>
                    Additional Add-on Packages
                  </Typography>
                  {addons.map((addon, index) => (
                    <Box key={addon.id} display="flex" justifyContent="space-between" alignItems="center" ml={1}>
                      <Typography variant="body1">
                        {addon.name} <span style={{ color: grey[600] }}>(+${addon.price})</span>
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <IconButton
                          color="primary"
                          component="label"
                          onClick={() => handleAddonChange(index, -1)}
                        >
                          <RemoveCircleOutlineOutlinedIcon />
                        </IconButton>
                        <Typography variant="body1" sx={{ mx: 1, minWidth: '20px', textAlign: 'center' }}>
                          {addon.qty}
                        </Typography>
                        <IconButton
                          color="primary"
                          component="label"
                          onClick={() => handleAddonChange(index, 1)}
                        >
                          <ControlPointOutlinedIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              {/* end addon list */}

            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                p: {
                  xs: 2,
                  md: 4,
                },
              }}>
              <Box
                sx={{
                  mb: {
                    xs: 4,
                    md: 8,
                  },
                }}>

                <Box mb={2}>
                  {resAvabilityDetail?.adult_pax > 0 && (
                    <Typography variant="body2" display="flex" justifyContent="space-between" color={grey[700]} mb={0.5}>
                      <span>{resAvabilityDetail?.adult_pax} Adult(s) x ${resAvabilityDetail?.adult_price}</span>
                      <span>${resAvabilityDetail?.adult_pax * resAvabilityDetail?.adult_price}</span>
                    </Typography>
                  )}
                  {resAvabilityDetail?.child_pax > 0 && (
                    <Typography variant="body2" display="flex" justifyContent="space-between" color={grey[700]} mb={0.5}>
                      <span>{resAvabilityDetail?.child_pax} Child(s) x ${resAvabilityDetail?.child_price}</span>
                      <span>${resAvabilityDetail?.child_pax * resAvabilityDetail?.child_price}</span>
                    </Typography>
                  )}
                  {resAvabilityDetail?.infant_pax > 0 && (
                    <Typography variant="body2" display="flex" justifyContent="space-between" color={grey[700]} mb={0.5}>
                      <span>{resAvabilityDetail?.infant_pax} Infant(s) x ${resAvabilityDetail?.infant_price}</span>
                      <span>${resAvabilityDetail?.infant_pax * resAvabilityDetail?.infant_price}</span>
                    </Typography>
                  )}
                </Box>

                {totalAddonPrice > 0 && (
                  <Box mb={2}>
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Add-ons
                    </Typography>
                    {addons.map((addon) => addon.qty > 0 && (
                      <Typography key={addon.id} variant="body2" display="flex" justifyContent="space-between" mb={0.5} color={grey[700]}>
                        <span>{addon.qty}x {addon.name}</span>
                        <span>${addon.qty * addon.price}</span>
                      </Typography>
                    ))}
                  </Box>
                )}

                <Box mt={3} pt={2} borderTop={`1px dashed ${grey[400]}`} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" fontWeight="bold">
                    Total Price
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" color="primary">
                    ${(resAvabilityDetail?.total_price || 0) + totalAddonPrice}
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  props.handleCheckAvailibility(date, travelers, selectedAddons);
                }}>
                Book Now
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}

      <Hr />
    </Container>
  );
};

export default Gallery;
